export const CALCULATE_CHEM_RISK_LEVEL = 'CALCULATE_CHEM_RISK_LEVEL';
export const CALCULATE_CHEM_RISK_LEVEL_SUCCESS = `${CALCULATE_CHEM_RISK_LEVEL}/SUCCESS`;
export const CALCULATE_CHEM_RISK_LEVEL_FAILURE = `${CALCULATE_CHEM_RISK_LEVEL}/FAILURE`;

export const CALCULATE_ENV_RISK = 'CALCULATE_ENV_RISK';
export const CALCULATE_ENV_RISK_SUCCESS = `${CALCULATE_ENV_RISK}/SUCCESS`;
export const CALCULATE_ENV_RISK_FAILURE = `${CALCULATE_ENV_RISK}/FAILURE`;

export const ENV_RISK_CALCULATION = 'ENV_RISK_CALCULATION';
export const CHEM_RISK_CALCULATION = 'CHEM_RISK_CALCULATION';

export const CLEAR_ENV_RISK_RESULT_DTO = 'CLEAR_ENV_RISK_RESULT_DTO';
export const CLEAR_CHEM_RISK_RESULT_DTO = 'CLEAR_CHEM_RISK_RESULT_DTO';

export default {
  CALCULATE_CHEM_RISK_LEVEL,
  CALCULATE_CHEM_RISK_LEVEL_SUCCESS,
  CALCULATE_CHEM_RISK_LEVEL_FAILURE,
  CALCULATE_ENV_RISK,
  CALCULATE_ENV_RISK_SUCCESS,
  CALCULATE_ENV_RISK_FAILURE,

  ENV_RISK_CALCULATION,
  CHEM_RISK_CALCULATION,

  CLEAR_ENV_RISK_RESULT_DTO,
  CLEAR_CHEM_RISK_RESULT_DTO,
};
